<div class="align-items-center">
  <div class="row">
    @for (card of multiProductCards(); track card) {
      <div class="col-12 col-lg-6 mb-4" (click)="cardClicked.emit(card)">
        @if (!useSelectableCards() || isOnlyOneVk()) {
          <mwe-multi-product-card
            [ngClass]="{ 'd-block pointer': hasMousePointerStyle() }"
            [card]="card"
            [isDisabled]="isDisabled()"
            [showCompanyReference]="showCompanyReference()"
            [showSummarizedCompanyReference]="showSummarizedCompanyReference()"
            [showAccountNumber]="showAccountNumber()"
            [showCustomerNumber]="showCustomerNumber()"
          >
            @if (showSlider() && !isDisabled) {
              <div class="card-basic-body py-3 border-top">
                <mwe-product-card-slider
                  [id]="card.id"
                  [initialValue]="card.isChecked"
                  [showCompanyReference]="showCompanyReference()"
                  toggleOnMsgKey="invoiceData.change.newAccount.toggleLabel.toggleOn"
                  toggleOffMsgKey="invoiceData.change.newAccount.toggleLabel.toggleOff"
                  (sliderState)="handleSliderResponse($event)"
                />
              </div>
            }
          </mwe-multi-product-card>
        } @else {
          <mwe-card-selectable
            [isSelected]="card.isChecked"
            data-test="mwe-multi-product-card"
            [disabled]="isDisabled()"
            (changed)="handleSliderResponse({ id: card.id, checked: $event })"
          >
            <div class="row gx-3">
              @for (category of card.categories; track category) {
                <div class="col-auto">
                  <mwe-product-icon [category]="category" size="lg" textNodeType="p" />
                  @if (showCompanyReference()) {
                    <span class="text--legal">
                      {{ category | correlatedCompanyReference }}
                    </span>
                  }
                </div>
              }
            </div>
            @if (showSummarizedCompanyReference() && !showCompanyReference() && card?.categories?.length > 0) {
              <div class="text--legal mt-1">
                {{ card.categories[0] | correlatedCompanyReference }}
              </div>
            }
          </mwe-card-selectable>
        }
      </div>
    }
  </div>
</div>
